export default __webpack_public_path__ + "static/media/banner-home-3.8c837113.png";